import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges, OnInit } from '@angular/core';
import { ToolsService } from 'tools';
import { CopyProtocolsResultDto } from 'UvExplorerServer.Dtos.TS/Tools';
import { MessageService } from 'base';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NetFacadeService, NavigationService } from 'netview';
import { IdentityService } from 'identity';
import { DiscResultsService } from '../../../discovery';
import { Subscription } from 'rxjs';
import { NetViewDto } from '../../../UvExplorerServer.Dtos.TS';


@Component({
	selector: 'copy-credentials',
	templateUrl: './copy-credentials.component.html',
	styleUrls: ['./copy-credentials.component.scss']
})
export class CopyCredentialsComponent implements OnInit {

	public form: UntypedFormGroup;

	public sourceNetwork: UntypedFormControl;
	public targetNetwork: UntypedFormControl;
	public doAll: UntypedFormControl;

	private allNetViews: NetViewDto[];
	public allNetViewNames: string[];

	private netViewTreeLoadedSub: Subscription;

	public displayCopyProtocolsConfirm: boolean;
	public copyProtocolsConfirmMessage: string;


	constructor(private fb: UntypedFormBuilder,
		private netFacadeService: NetFacadeService,
		private toolsService: ToolsService,
		private messageService: MessageService, private navService: NavigationService,
		private identityService: IdentityService, private discResultsService: DiscResultsService) {

		let doAll = false;

		this.allNetViews = [];
		this.allNetViewNames = [];
		this.displayCopyProtocolsConfirm = false;
		this.copyProtocolsConfirmMessage = "";

		this.sourceNetwork = new UntypedFormControl("", Validators.required);
		this.targetNetwork = new UntypedFormControl("", Validators.required);
		this.doAll = new UntypedFormControl(doAll);

		this.form = this.fb.group({
			sourceNetwork: this.sourceNetwork,
			targetNetwork: this.targetNetwork,
			doAll: this.doAll,
		});

		this.rebuildNetworkList();
		this.onGotData();
	}

	private rebuildNetworkList(): void {
		if (this.netFacadeService.netviews) {
			this.allNetViews = [...this.netFacadeService.netviews];
			this.allNetViews.sort((a, b) => a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1);
		}
	}

	ngOnInit(): void {

		this.initData();
	}

	private initData(): void {
	}

	private onGotData(): void {

		if (!!this.allNetViews) {

			this.allNetViewNames = [];

			this.allNetViews.forEach((netView: NetViewDto) => {
				if (netView.Name && (netView.Name.length !== 0)) {
					this.allNetViewNames.push(netView.Name);
				}
			});

			let firstNetworkName: string = ((this.allNetViewNames.length > 0) ? this.allNetViewNames[0] : "");
			let secondNetworkName: string = ((this.allNetViewNames.length > 1) ? this.allNetViewNames[1] : "");
			this.sourceNetwork.setValue(firstNetworkName);
			this.targetNetwork.setValue(secondNetworkName);
		}
	}

	public get enableCopy(): boolean {
		return (!!this.sourceNetwork.value && !!this.targetNetwork.value)
	}

	private getNetViewGuidByName(nvName:string): string {
		let netViewGuid: string = "";

		if (!!this.allNetViews) {

			this.allNetViews.forEach((netView: NetViewDto) => {
				if (netView.Name && (netView.Name.length !== 0)) {
					if (netView.Name == nvName) {
						netViewGuid = netView.Guid;
						return netViewGuid;
					}
				}
			});
		}

		return netViewGuid;
	}

	public tryCopyProtocols(): void {
		this.displayCopyProtocolsConfirm = true;
	}

	public doCopy(): void {

		let sessionGuid = this.identityService.sessionGuid;

		this.messageService.startWork();
		this.toolsService.copyNetworkProtocols(sessionGuid, this.sourceNetwork.value, this.targetNetwork.value, this.doAll.value).subscribe(
			(result: CopyProtocolsResultDto) => {
				this.messageService.endWork();
				if (result.message) {
					this.messageService.displayInfoMessage(result.message);
				}
				else {
					this.messageService.displayInfoMessage("Copy protocols was successful.")
				}

				let sourceNetViewDto = null;
				let targetNetViewDto = null;

				let sourceNetViewGuid = this.getNetViewGuidByName(this.sourceNetwork.value);
				if (sourceNetViewGuid) {
					sourceNetViewDto = this.netFacadeService.getNetViewFromTree(sourceNetViewGuid);
				}

				let targetNetViewGuid = this.getNetViewGuidByName(this.targetNetwork.value);
				if (targetNetViewGuid) {
					targetNetViewDto = this.netFacadeService.getNetViewFromTree(targetNetViewGuid);
				}

				if (sourceNetViewDto && targetNetViewDto) {

				}
				setTimeout(() => window.location.reload(), 2000);				
			},
			(error) => {
				this.messageService.endWork();
				this.messageService.displayErrorMessage("Copy protocols failed.");
			});
	}

	public copyProtocols(): void {
		this.doCopy();
		this.displayCopyProtocolsConfirm = false;
    }

	public cancelCopyProtocols(): void {
		this.copyProtocolsConfirmMessage = "";
		this.displayCopyProtocolsConfirm = false;
	}

}
